import { Component, input, signal } from '@angular/core';

let nextId = 0;

// A small "?" that explains a term on hover, keyboard focus or touch; Escape dismisses it.
@Component({
  selector: 'app-info-tip',
  template: `
    <button
      type="button"
      class="tip"
      [attr.aria-label]="label()"
      [attr.aria-describedby]="id"
      (mouseenter)="open.set(true)"
      (mouseleave)="open.set(false)"
      (focus)="open.set(true)"
      (blur)="open.set(false)"
      (click)="open.set(!open())"
      (keydown.escape)="open.set(false)"
    >
      ?
    </button>
    <span
      class="bubble"
      role="tooltip"
      [id]="id"
      [class.visible]="open()"
      [class.end]="align() === 'end'"
      >{{ text() }}</span
    >
  `,
  styleUrl: './info-tip.css',
})
export class InfoTip {
  readonly text = input.required<string>();
  readonly label = input('More information');
  // Which edge of the "?" the bubble lines up with; use "end" near the right side of the page.
  readonly align = input<'start' | 'end'>('start');

  protected readonly id = `info-tip-${nextId++}`;
  protected readonly open = signal(false);
}
